
























































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import {
  Account, SignedTransaction, RepositoryFactoryHttp,
  TransactionService, HashLockTransaction, Deadline,
  UInt64, Address, NetworkCurrencies,
} from 'symbol-sdk';
import * as fileReader from 'promise-file-reader';
import { AnnounceInfo } from 'simple-apostille-v2/dist/src/model/AnnounceInfo';
import { saveAs } from 'file-saver';

// eslint-disable-next-line import/extensions
import { HashFunctionCreator, HashingType } from 'simple-apostille-v2';
// eslint-disable-next-line import/extensions
import ApostilleService from '../libs/ApostilleService';
import Alert from '../components/createapostille/Alert.vue';
import TransactionSigner from '../components/createapostille/TransactionSigner.vue';
import FileDropArea from '../components/createapostille/FileDropArea.vue';
import ProgressDialog from '../components/ProgressDialogComponent.vue';
import AppConfig from '../libs/AppConfig';
import IMetadata from '../models/AIMetadata';
import Snackbar from '../util/snackbar';

@Component({
  components: {
    ProgressDialog,
    Alert,
    TransactionSigner,
    FileDropArea,
  },
})
export default class CreateApostillePage extends Vue {
  @Prop()
  public showSnackbar!: (text: string) => void

  private isValid = false;

  private isLoading = false;

  private isCompleteDialog = false;

  private file: File | null = null;

  private fileRules = [
    (v: File) => !!v || 'ファイルを設定してください',
  ];

  private signerAccount?: Account;

  private signerKey = '';

  private signerAddress = '';

  private txHash = '';

  private tmpOwner = '';

  private owners: Address[] = [];

  private cOwners: string[] = [];

  private repositoryFactory?: RepositoryFactoryHttp;

  private completeMessage = '署名済のファイルをダウンロードしてください。\n署名済のファイルは監査時に利用します。\nファイル名は変更しないでください';

  private apostilleButtonDisable = true;

  private networkType = AppConfig.networkType();

  private epochAdjustment = AppConfig.epochAdjustment();

  private metadataKeys = [
    { value: 'author', text: '作者' },
    { value: 'title', text: 'タイトル' },
    { value: 'tag', text: 'タグ' },
    { value: 'description', text: '説明' },
    { value: 'originUrl', text: 'URL' },
  ];

  private tmpKey = '';

  private tmpKeyName = '';

  private tmpValue = '';

  private metadatas: IMetadata[] = [];

  mounted() {
    this.createRepositoryFactory();
  }

  private onChangeSignerKey(val: string) {
    this.signerKey = val;
    this.signerAccount = Account.createFromPrivateKey(val, this.networkType);
    this.signerAddress = this.signerAccount.address.pretty();
    this.apostilleButtonDisable = false;
  }

  private onClickAddOwner() {
    try {
      const address = Address.createFromRawAddress(this.tmpOwner);
      if (this.cOwners.includes(address.plain())) {
        this.showSnackbar(Snackbar.DEPLICATE_ADDRESS);
        return;
      }
      this.owners.push(address);
      this.cOwners.push(address.plain());
      this.tmpOwner = '';
    } catch (err) {
      console.error(err);
      this.showSnackbar(Snackbar.INVALID_ADDRESS);
    }
  }

  private onMetadataKeyChanged() {
    const mk = this.metadataKeys.find((k) => k.value === this.tmpKey);
    if (mk) {
      this.tmpKeyName = mk.text;
    }
  }

  private onClickAddMetadata() {
    const metadata: IMetadata = {
      key: this.tmpKey,
      keyName: this.tmpKeyName,
      value: this.tmpValue,
    };

    if (this.tmpKey === '' || this.tmpValue === '') {
      this.showSnackbar(Snackbar.INVALID_METADATA);
      return;
    }

    const k = this.metadatas.find((f) => f.key === this.tmpKey);
    if (!k) {
      this.metadatas.push(metadata);
      this.tmpKey = '';
      this.tmpKeyName = '';
      this.tmpValue = '';
    } else {
      this.showSnackbar(Snackbar.DEPLICATE_METADATA);
    }
  }

  private onClickRemoveOwner(index: number) {
    this.owners.splice(index, 1);
    this.cOwners.splice(index, 1);
  }

  private onClickRemoveMetadata(index: number) {
    this.metadatas.splice(index, 1);
  }

  private createRepositoryFactory() {
    this.repositoryFactory = new RepositoryFactoryHttp(
      AppConfig.apiEndpoint(), {
        generationHash: AppConfig.generationHash(),
        networkType: this.networkType,
        websocketUrl: `${AppConfig.apiEndpoint().replace('http', 'ws')}/ws`,
        websocketInjected: WebSocket,
      },
    );
  }

  private async onClickCreate() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const refs: any = this.$refs;
    if (refs.form.validate() && this.file && this.signerAccount) {
      try {
        const fileHash = await this.fileHashing();
        const announceInfo = await ApostilleService.createAnnounceInfo(
          fileHash,
          this.file.name,
          this.signerAccount,
          this.owners,
          this.metadatas,
        );
        if (announceInfo) {
          this.txHash = announceInfo.signedTransaction.hash;
          this.annouceTransaction(announceInfo);
        }
      } catch (err) {
        console.error(err);
      }
    }
  }

  private async fileHashing() {
    const fileBuffer = await fileReader.readAsArrayBuffer(this.file);
    const hashFunc = HashFunctionCreator.create(HashingType.Type.sha256);
    return hashFunc.hashing(fileBuffer);
  }

  private annouceTransaction(annouceInfo: AnnounceInfo) {
    if (annouceInfo.shouldUseHashLockTransaction) {
      this.annouceTransactionByBonded(annouceInfo.signedTransaction);
    } else {
      this.annouceTransactionByComplete(annouceInfo.signedTransaction);
    }
  }

  private annouceTransactionByBonded(signedTx: SignedTransaction) {
    const signedHashLockTx = this.createSignedHashLockTx(signedTx);

    const transactionService = this.createTransactionSerivce();
    const listener = this.createListener();
    this.isLoading = true;

    if (transactionService && listener) {
      listener.open().then(() => {
        transactionService.announceHashLockAggregateBonded(
          signedHashLockTx, signedTx, listener,
        ).subscribe((x) => {
          listener.close();
          this.isLoading = false;
          if (x.transactionInfo && x.transactionInfo.hash) {
            this.showCompleteDialog();
          }
        }, (err) => {
          console.error(err);
          listener.close();
          this.isLoading = false;
          this.showSnackbar(Snackbar.FAILED_APOSTILLE);
        });
      }).catch((err) => {
        console.error(err);
        listener.close();
        this.isLoading = false;
        this.showSnackbar(Snackbar.FAILED_APOSTILLE);
      });
    }
  }

  private createSignedHashLockTx(signedTx: SignedTransaction) {
    if (this.signerAccount) {
      const hashLockTx = HashLockTransaction.create(
        Deadline.create(this.epochAdjustment),
        NetworkCurrencies.PUBLIC.currency.createRelative(10),
        UInt64.fromUint(480),
        signedTx,
        this.networkType,
      ).setMaxFee(AppConfig.feeMultiplier());

      const signedHashLockTx = this.signerAccount.sign(hashLockTx,
        AppConfig.generationHash());
      return signedHashLockTx;
    }
    throw Error('Failed create Hashlock Tx');
  }

  private annouceTransactionByComplete(signedTx: SignedTransaction) {
    const transactionService = this.createTransactionSerivce();
    const listener = this.createListener();
    this.isLoading = true;

    if (transactionService && listener) {
      listener.open().then(() => {
        transactionService.announce(signedTx, listener).subscribe((x) => {
          listener.close();
          this.isLoading = false;
          if (x.transactionInfo && x.transactionInfo.hash) {
            this.showCompleteDialog();
          }
        }, (err) => {
          console.error(err);
          listener.close();
          this.isLoading = false;
          this.showSnackbar(Snackbar.FAILED_APOSTILLE);
        });
      }).catch((err) => {
        console.error(err);
        listener.close();
        this.isLoading = false;
        this.showSnackbar(Snackbar.FAILED_APOSTILLE);
      });
    }
  }

  private createTransactionSerivce() {
    if (this.repositoryFactory) {
      return new TransactionService(
        this.repositoryFactory.createTransactionRepository(),
        this.repositoryFactory.createReceiptRepository(),
      );
    }
    return null;
  }

  private createListener() {
    if (this.repositoryFactory) {
      return this.repositoryFactory.createListener();
    }
    return null;
  }

  private showCompleteDialog() {
    this.isCompleteDialog = true;
  }

  private onClickDownloadButton() {
    this.isCompleteDialog = false;
    this.saveApostilleFile();
  }

  private saveApostilleFile() {
    if (this.file) {
      const filename = ApostilleService.createApostilleFileName(this.file.name, this.txHash);
      saveAs(this.file, filename);
    }
  }

  private isDragOver = false;

  private image = null;

  private onDrag(type: string) {
    this.isDragOver = type === 'over';
  }

  private onChange(event: any) {
    const { files } = event.target;
    this.file = files[0] as File;
  }

  private onClickRemoveFile() {
    this.file = null;
  }
}
